import Reflux from 'reflux';
import LatestCommentsActions from '../actions/LatestCommentsActions';
import axios from 'axios';

export default class LatestCommentsStore extends Reflux.Store {
    constructor () {
        super();
        this.state = {
            latestComments: [],
            apiUrl: process.env.REACT_APP_API_URL + '/api'
        };
        this.listenables = LatestCommentsActions;
    }

    onGetLatestComments () {
        this.setState({searching: true});
        axios.get(this.state.apiUrl + '/comments/?conditions={"usertopic":{"$ne":null}}&sort=-createdAt&limit=4&populate=createdBy usertopic')
          .then((resp) => {
              this.setState({latestComments: resp.data});
          })
          .catch((error) => {
              console.error(error);
          });
    }
}



// WEBPACK FOOTER //
// ./src/stores/LatestCommentsStore.js